import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Injects Google Analytics (GA4) + Google Search Console verification
 * only when the corresponding env vars are provided. Keeps the build clean
 * for local/preview environments.
 *
 * To activate, add to /app/frontend/.env:
 *   REACT_APP_GA_ID=G-XXXXXXXXXX
 *   REACT_APP_GSC_VERIFICATION=your-search-console-meta-value
 */
export default function Analytics() {
    const gaId = process.env.REACT_APP_GA_ID;
    const gscToken = process.env.REACT_APP_GSC_VERIFICATION;

    return (
        <Helmet>
            {gscToken && <meta name="google-site-verification" content={gscToken} />}
            {gaId && (
                <script async src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`} />
            )}
            {gaId && (
                <script>{`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${gaId}', { anonymize_ip: true });
                `}</script>
            )}
        </Helmet>
    );
}
